__webpack_require__.p = "/events/uinfo/dist/";